export default "__VITE_ASSET__D8JTwn_9__"